/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import {
  Modal,
  Col,
  Typography,
  Form,
  Row,
  Input,
  Button,
  message,
  Spin,
  Table,
  Tooltip,
  DatePicker,
  notification,
  Select,
  InputNumber,
  Upload,
} from 'antd';
import {
  ImportOutlined,
  EditOutlined,
  DeleteOutlined,
  UploadOutlined,
  CloudUploadOutlined,
  CloseOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  TeamOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from '@ant-design/icons';
import { Download, Import, Plus } from 'lucide-react';
import { Button as CrcButton, Spinner } from '@crc-evans/ui-components';
import {
  fetchEmployeesList,
  addEmployee,
  updateEmployee,
  uploadBulkEmployeeList,
  deleteEmployee,
} from '../redux/admin/employees/action';
import * as XLSX from 'xlsx';
import axios from 'axios';
import moment from 'moment';
import get from 'lodash/get';
const { Title, Text } = Typography;
import { connect } from 'react-redux';
import '../pages/technical/HeatProfilePage.css';
import './AdminEmployees.css';
import { useHeatStyleColumnFacets } from './technical/heatStyleColumnFacets';

const EMPLOYEE_FACET_KEYS = ['coCd', 'personNumber', 'costCenter', 'employeeName', 'startDateLabel', 'endDateLabel'];
// import CommonAGGridTable from './AG Grid/CommonAGGridTable';

const convertExcelDate = (serial) => {
  if (typeof serial === 'number') {
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);

    const fractional_day = serial - Math.floor(serial);
    const total_seconds = Math.floor(86400 * fractional_day);

    const seconds = total_seconds % 60;
    const hours = Math.floor(total_seconds / 3600);
    const minutes = Math.floor(total_seconds / 60) % 60;

    return new Date(
      Date.UTC(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      )
    );
  }
  return null;
};

const AdminEmployees = (props) => {
  const {
    onFetchEmployeesList,
    onAddEmployee,
    onUpdateEmployee,
    onUploadBulkEmployeeList,
    onDeleteEmployee,
    employeeList,
    isEmployeeListLoading,
  } = props;

  const [fileModalVisible, setFileModalVisible] = useState(false);
  const [formModalVisible, setFormModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [ratesHeader, setRatesHeader] = useState([
    'CoCd',
    'PersNo',
    'Cost Ctr',
    'Name of Employee or Applicant',
    'Start Date',
    'End Date',
  ]);
  const [uploadedData, setUploadedData] = useState([...employeeList]);

  const EMPLOYEE_COL_SEARCH_INITIAL = {
    sno: '',
    coCd: '',
    personNumber: '',
    costCenter: '',
    employeeName: '',
    startDate: '',
    endDate: '',
  };
  const [colSearch, setColSearch] = useState(EMPLOYEE_COL_SEARCH_INITIAL);
  const [sortKey, setSortKey] = useState('employeeName');
  const [sortDesc, setSortDesc] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [employeeId, setEmployeeId] = useState('');
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  const [userForm] = Form.useForm();
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);

  const generateColumns = async () => {
    const columnDefs = [
      {
        headerName: 'S.No',
        field: 'sno',
        maxWidth: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        valueGetter: (params) => params.data.sno,
        suppressMovable: true,
        lockPosition: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },

      {
        headerName: 'CoCd',
        field: 'coCd',
        width: 120,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
        cellRenderer: (params) => truncateTableData(params.value),
      },
      {
        headerName: 'PersNo',
        field: 'personNumber',
        width: 120,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
        cellRenderer: (params) => truncateTableData(params.value),
      },
      {
        headerName: 'Cost Ctr',
        field: 'costCenter',
        width: 120,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Name of Employee',
        field: 'employeeName',
        width: 200,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
        cellRenderer: (params) => truncateTableData(params.value),
      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        width: 150,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: ['equals', 'greaterThan', 'lessThan'],
          buttons: ['reset'],
        },
        cellRenderer: (params) => {
          if (!params.value) return '-';
          const date = moment(params.value);
          return date.isValid() ? date.format('DD-MM-YYYY') : '-';
        },
      },
      {
        headerName: 'End Date',
        field: 'endDate',
        width: 150,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: ['equals', 'greaterThan', 'lessThan'],
          buttons: ['reset'],
        },
        cellRenderer: (params) => {
          if (!params.value) return '-';
          const date = moment(params.value);
          return date.isValid() ? date.format('DD-MM-YYYY') : '-';
        },
      },
      {
        headerName: 'Actions',
        field: 'actions',
        width: 120,
        cellStyle: { textAlign: 'center' },
        suppressMovable: true,
        lockPosition: true,
        pinned: 'right',
        filter: false,
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <div>
              <Tooltip title="Edit">
                <EditOutlined
                  className="txtIcon"
                  style={{ marginLeft: '10px', fontSize: '18px' }}
                  onClick={() => showAddEditListModal(record, true)}
                />
              </Tooltip>
              <Tooltip title="Delete">
                <DeleteOutlined
                  className="txtIcon"
                  style={{ marginLeft: '10px', fontSize: '18px' }}
                  onClick={() => handleDeletion(record)}
                />
              </Tooltip>
            </div>
          );
        },
      },
    ];

    setColumnDefs(columnDefs);
    return columnDefs;
  };
  useEffect(() => {
    generateColumns();
  }, []);

  useEffect(() => {
    onFetchEmployeesList();
  }, []);
  //
  useEffect(() => {
    if (employeeList && employeeList.length) {
      const list = employeeList.map((item, i) => ({
        ...item,
        sno: i + 1,
      }));
      setUploadedData(list);
    } else {
      setUploadedData([]);
    }
  }, [employeeList]);

  const updateColSearch = useCallback((field, value) => {
    setColSearch((prev) => ({ ...prev, [field]: value }));
  }, []);

  const employeesWithLabels = useMemo(
    () =>
      (uploadedData || []).map((r) => ({
        ...r,
        startDateLabel:
          r.startDate && moment(r.startDate).isValid() ? moment(r.startDate).format('DD-MMM-YYYY') : '',
        endDateLabel:
          r.endDate && moment(r.endDate).isValid() ? moment(r.endDate).format('DD-MMM-YYYY') : '',
      })),
    [uploadedData]
  );

  const employeesFacetListRef = useRef([]);
  employeesFacetListRef.current = employeesWithLabels;
  const fetchEmployeeFacetRows = useCallback(async () => {
    const list = employeesFacetListRef.current;
    return Array.isArray(list) ? [...list] : [];
  }, []);

  const searchCriteriaEmployeeFacets = useMemo(() => ({}), []);

  const columnFiltersForFacets = useMemo(
    () => ({
      ...colSearch,
      startDateLabel: colSearch.startDate,
      endDateLabel: colSearch.endDate,
    }),
    [colSearch]
  );

  const handleFacetColumnFilterChange = useCallback(
    (key, value) => {
      if (key === 'startDateLabel') updateColSearch('startDate', value);
      else if (key === 'endDateLabel') updateColSearch('endDate', value);
      else updateColSearch(key, value);
    },
    [updateColSearch]
  );

  const { applyFacetClientFilter, renderTextColumnFilterTrigger } = useHeatStyleColumnFacets({
    enabled: true,
    filterableColumns: EMPLOYEE_FACET_KEYS,
    listCount: (employeesWithLabels || []).length,
    projectList: employeesWithLabels || [],
    searchCriteria: searchCriteriaEmployeeFacets,
    columnFilters: columnFiltersForFacets,
    onColumnFilterChange: handleFacetColumnFilterChange,
    fetchFacetRows: fetchEmployeeFacetRows,
  });

  const handleSortClick = useCallback((field) => {
    setSortKey((prev) => {
      if (prev === field) {
        setSortDesc((d) => !d);
        return prev;
      }
      setSortDesc(false);
      return field;
    });
  }, []);

  const tableDataSource = useMemo(() => {
    let list = [...employeesWithLabels];
    const lc = (v) => (v == null ? '' : String(v)).trim().toLowerCase();

    if (colSearch.sno.trim()) {
      const q = colSearch.sno.trim();
      list = list.filter((r) => String(r.sno ?? '').includes(q));
    }
    if (colSearch.coCd.trim()) {
      const q = lc(colSearch.coCd);
      list = list.filter((r) => lc(r.coCd).includes(q));
    }
    if (colSearch.personNumber.trim()) {
      const q = lc(colSearch.personNumber);
      list = list.filter((r) => lc(r.personNumber).includes(q));
    }
    if (colSearch.costCenter.trim()) {
      const q = lc(colSearch.costCenter);
      list = list.filter((r) => lc(r.costCenter).includes(q));
    }
    if (colSearch.employeeName.trim()) {
      const q = lc(colSearch.employeeName);
      list = list.filter((r) => lc(r.employeeName).includes(q));
    }
    if (colSearch.startDate.trim()) {
      const q = lc(colSearch.startDate);
      list = list.filter((r) => {
        if (!r.startDate) return false;
        const d = moment(r.startDate);
        if (!d.isValid()) return false;
        return (
          d.format('DD-MMM-YYYY').toLowerCase().includes(q) ||
          d.format('DD-MM-YYYY').toLowerCase().includes(q) ||
          d.format('YYYY-MM-DD').toLowerCase().includes(q)
        );
      });
    }
    if (colSearch.endDate.trim()) {
      const q = lc(colSearch.endDate);
      list = list.filter((r) => {
        if (!r.endDate) return false;
        const d = moment(r.endDate);
        if (!d.isValid()) return false;
        return (
          d.format('DD-MMM-YYYY').toLowerCase().includes(q) ||
          d.format('DD-MM-YYYY').toLowerCase().includes(q) ||
          d.format('YYYY-MM-DD').toLowerCase().includes(q)
        );
      });
    }

    list = applyFacetClientFilter(list);

    list.sort((a, b) => {
      if (sortKey === 'sno') {
        const va = Number(a.sno) || 0;
        const vb = Number(b.sno) || 0;
        return sortDesc ? vb - va : va - vb;
      }
      if (sortKey === 'startDate' || sortKey === 'endDate') {
        const ta = a[sortKey] ? moment(a[sortKey]).valueOf() : 0;
        const tb = b[sortKey] ? moment(b[sortKey]).valueOf() : 0;
        return sortDesc ? tb - ta : ta - tb;
      }
      const va = (a[sortKey] ?? '').toString();
      const vb = (b[sortKey] ?? '').toString();
      const cmp = va.localeCompare(vb, undefined, { sensitivity: 'base' });
      return sortDesc ? -cmp : cmp;
    });
    return list;
  }, [employeesWithLabels, colSearch, sortKey, sortDesc, applyFacetClientFilter]);

  useEffect(() => {
    setCurrent(1);
  }, [colSearch, uploadedData]);

  const truncateTableData = (data) => {
    return (
      <Tooltip
        placement="topLeft"
        title={data}
      >
        {data}
      </Tooltip>
    );
  };

  //Edit employee list data
  const showAddEditListModal = async (record, edit) => {
    let userDt = {};
    if (record !== '') {
      record.startDate = moment(record.startDate);
      record.endDate = moment(record.endDate);
      userForm.setFieldsValue(record);
      setEmployeeId(record.id);
    }
    setIsEdit(edit);
    setFormModalVisible(true);
  };

  const handleDeletion = (record) => {
    setEmployeeToDelete(record);
    setDeleteModalOpen(true);
  };

  const handleDeleteModalCancel = () => {
    setDeleteModalOpen(false);
    setEmployeeToDelete(null);
  };

  const handleConfirmDelete = () => {
    if (!employeeToDelete) return;
    try {
      onDeleteEmployee({ id: employeeToDelete.id });
      setDeleteModalOpen(false);
      setEmployeeToDelete(null);
    } catch (error) {
      console.error('Error deleting data:', error);
      message.error('Data delete failed.');
    }
  };

  const renderSortCaretEmployee = useCallback(
    (field) =>
      sortKey === field ? (
        sortDesc ? (
          <CaretDownOutlined className="equipment-type-sort-dir-icon" aria-hidden />
        ) : (
          <CaretUpOutlined className="equipment-type-sort-dir-icon" aria-hidden />
        )
      ) : (
        <CaretUpOutlined
          className="equipment-type-sort-dir-icon doc-control-sort-caret-inactive"
          aria-hidden
        />
      ),
    [sortKey, sortDesc]
  );

  const facetKeyForField = (field) => {
    if (field === 'startDate') return 'startDateLabel';
    if (field === 'endDate') return 'endDateLabel';
    return field;
  };

  const makeSortableHeader = useCallback(
    (label, field, compactNameSearch = false) => {
      function EmployeeSortableColumnHeader() {
        const facetKey = facetKeyForField(field);
        const showFacet = field !== 'sno';
        return (
          <div className="column-header-with-filter">
            <div className="column-header-text-wrapper spares-column-header-sortable">
              <span>{label}</span>
              <span
                className="custom-sort-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleSortClick(field);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleSortClick(field);
                  }
                }}
              >
                {renderSortCaretEmployee(field)}
              </span>
              {showFacet ? renderTextColumnFilterTrigger(facetKey) : null}
            </div>
            <div
              className={`header-filter-input user-mgmt-header-search${
                compactNameSearch ? ' employees-name-header-search-wrap' : ''
              }`}
            >
              <div className="heat-profile-inline-field-shell heat-profile-inline-field-shell--sm heat-profile-header-inline-shell">
                <Input
                  placeholder="Search..."
                  value={colSearch[field]}
                  onChange={(e) => updateColSearch(field, e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  size="small"
                  style={{ width: '100%' }}
                  className={compactNameSearch ? 'employees-table-name-search-input' : undefined}
                />
              </div>
            </div>
          </div>
        );
      }
      EmployeeSortableColumnHeader.displayName = `EmployeeSortableColumnHeader(${field})`;
      return EmployeeSortableColumnHeader;
    },
    [colSearch, handleSortClick, updateColSearch, renderSortCaretEmployee, renderTextColumnFilterTrigger]
  );

  const columns = useMemo(
    () => [
      {
        title: makeSortableHeader('S.NO', 'sno'),
        dataIndex: 'sno',
        key: 'sno',
        width: 88,
        align: 'center',
        render: (text, record, index) => (current - 1) * pageSize + index + 1,
      },
      {
        title: makeSortableHeader('COCD', 'coCd'),
        dataIndex: 'coCd',
        key: 'coCd',
        width: 110,
        render: (data) => truncateTableData(data),
      },
      {
        title: makeSortableHeader('PERSNO', 'personNumber'),
        dataIndex: 'personNumber',
        key: 'personNumber',
        width: 130,
        render: (data) => truncateTableData(data),
      },
      {
        title: makeSortableHeader('COST CTR', 'costCenter'),
        dataIndex: 'costCenter',
        key: 'costCenter',
        width: 130,
        render: (data) => truncateTableData(data),
      },
      {
        title: makeSortableHeader('NAME OF EMPLOYEE', 'employeeName', true),
        dataIndex: 'employeeName',
        key: 'employeeName',
        width: 220,
        ellipsis: true,
        render: (data) => truncateTableData(data),
      },
      {
        title: makeSortableHeader('START DATE', 'startDate'),
        dataIndex: 'startDate',
        key: 'startDate',
        width: 150,
        render: (text) => (text ? moment(text).format('DD-MMM-YYYY') : '-'),
      },
      {
        title: makeSortableHeader('END DATE', 'endDate'),
        dataIndex: 'endDate',
        key: 'endDate',
        width: 150,
        render: (text) => (text ? moment(text).format('DD-MMM-YYYY') : '-'),
      },
      {
        title: <span className="equipment-type-column-title">ACTIONS</span>,
        dataIndex: 'actions',
        key: 'actions',
        width: 120,
        align: 'center',
        render: (text, record) => (
          <div className="heat-profile-actions-cell">
            <Tooltip title="Edit">
              <EditOutlined
                className="txtIcon"
                style={{ fontSize: '18px', cursor: 'pointer', marginRight: '16px' }}
                onClick={() => showAddEditListModal(record, true)}
              />
            </Tooltip>
            <Tooltip title="Delete">
              <DeleteOutlined
                className="txtIcon"
                style={{ fontSize: '18px', cursor: 'pointer' }}
                onClick={() => handleDeletion(record)}
              />
            </Tooltip>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps -- modal handlers stable enough per render
    [makeSortableHeader, current, pageSize]
  );

  const fileProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setDisableFileUpload(false);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      setDisableFileUpload(true);
      return false;
    },
    fileList,
  };

  //handle to add and update employees
  const handleOk = () => {
    let payload = {};
    userForm
      .validateFields()
      .then((data) => {
        const {
          coCd = '',
          personNumber = '',
          costCenter = '',
          employeeName = '',
          startDate,
          endDate,
        } = data;

        if (
          coCd.trim() &&
          personNumber.trim() &&
          costCenter.trim() &&
          employeeName.trim() &&
          startDate &&
          endDate
        ) {
          payload = {
            coCd: coCd.trim(),
            personNumber: personNumber.trim(),
            costCenter: costCenter.trim(),
            employeeName: employeeName.trim(),
            startDate,
            endDate,
          };
          if (isEdit) {
            onUpdateEmployee({ data: { employee: payload }, id: employeeId });
            resetFields();
          } else {
            onAddEmployee(payload);
            resetFields();
          }
        } else {
          notification.warning({
            message: 'Fill all the required fields!',
          });
        }
      })
      .catch((errorInfo) => {
        console.log('Validation Failed:', errorInfo);
      });
  };

  const resetFields = () => {
    setTimeout(() => {
      setFormModalVisible(false);
      userForm.resetFields();
      setFileList([]);
      setDisableFileUpload(false);
      setIsEdit(false);
    }, 1000);
  };
  //read excel file
  const readExcelFile = async (file) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: 'array' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    // excel file validation
    const requiredHeaders = [
      'CoCd',
      'PersNo',
      'Cost Ctr',
      'Name of Employee or Applicant',
      'Start Date',
      'End Date',
    ];
    const fileHeaders = json[0];
    const hasAllHeaders = requiredHeaders.every((header) => fileHeaders.includes(header));
    if (!hasAllHeaders) {
      notification.error({
        message: 'Invalid File Structure',
        description: `The uploaded file does not have the required headers: ${requiredHeaders.join(
          ', '
        )}.`,
      });
      return;
    }

    // Ensure no cells are empty
    for (let i = 1; i < json.length; i++) {
      const row = json[i];
      for (let j = 0; j < requiredHeaders.length; j++) {
        if (!row[j] && row[j] !== 0) {
          // Check if the cell is empty or undefined, but allow 0
          notification.error({
            message: 'Invalid File Data',
            description: `The uploaded file has empty cells in row ${i + 1}, column ${fileHeaders[j]
              }. Please ensure all cells are filled.`,
          });
          return;
        }
      }
    }

    // const headers = json[0].map(cleanKey);
    const headers = ['coCd', 'personNumber', 'costCenter', 'employeeName', 'startDate', 'endDate'];
    json.shift();

    const arrayOfObjects = json.map((row) => {
      let obj = {};
      row.forEach((cell, i) => {
        obj[headers[i]] = cell;
      });
      return obj;
    });

    return arrayOfObjects;
  };
  //
  const handleFileUpload = async () => {
    if (fileList.length > 0) {
      const data = await readExcelFile(fileList[0]);
      if (data?.length > 0) {
        const convertedData = data.map((record) => {
          let convertedStartDate;
          let convertedEndDate;

          if (typeof record.startDate === 'number') {
            convertedStartDate = convertExcelDate(record.startDate);
          } else if (typeof record.startDate === 'string') {
            convertedStartDate = moment(record.startDate, 'DD-MM-YYYY').toDate();
          }

          if (typeof record.endDate === 'number') {
            convertedEndDate = convertExcelDate(record.endDate);
          } else if (typeof record.endDate === 'string') {
            convertedEndDate = moment(record.endDate, 'DD-MM-YYYY').toDate();
          }
          return {
            ...record,
            startDate: convertedStartDate,
            endDate: convertedEndDate,
          };
        });

        await onUploadBulkEmployeeList({ data: convertedData });
        setTimeout(() => {
          setFileModalVisible(false);
          setFileList([]);
          setDisableFileUpload(false);
        }, 1000);
      }
    } else {
      notification.warn({ message: 'Please select a file to upload.' });
    }
  };

  const handleDownloadExcel = () => {
    const workbook = XLSX.utils.book_new();

    // Define the headers and their corresponding keys in uploadedData
    const headers = [
      { header: 'CoCd', key: 'coCd' },
      { header: 'PersNo', key: 'personNumber' },
      { header: 'Cost Ctr', key: 'costCenter' },
      { header: 'Name of Employee or Applicant', key: 'employeeName' },
      { header: 'Start Date', key: 'startDate' },
      { header: 'End Date', key: 'endDate' },
    ];

    // Add headers to the worksheet data
    const worksheetData = [headers.map((h) => h.header)];

    // Add data rows to the worksheet data
    uploadedData.forEach((dataRow) => {
      const row = headers.map((h) => {
        // Convert dates to a readable format if necessary
        if (h.key === 'startDate' || h.key === 'endDate') {
          return dataRow[h.key] ? moment(dataRow[h.key]).format('DD-MM-YYYY') : '';
        }
        return dataRow[h.key];
      });
      worksheetData.push(row);
    });

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'EmployeeData');
    // Write the workbook to a binary string
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    // Convert the binary string to a blob
    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
    // Trigger the download
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'EmployeeList.xlsx';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // Helper function to convert string to ArrayBuffer
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  const handleCancel = () => {
    setIsEdit(false);
    userForm.resetFields();
    setFormModalVisible(false);
  };
  //
  const modalToImportFile = () => {
    setFileModalVisible(true);
  };
  //
  const handleCancelUploadFile = () => {
    setFileModalVisible(false);
  };
  return (
    <>
      <div className="heat-profile-content-wrapper">
        <div className="heat-profile-card">
          <div className="heat-profile-list-header">
            <div className="heat-profile-header-left">
              <div className="heat-profile-icon-wrap">
                <TeamOutlined style={{ fontSize: 22 }} />
              </div>
              <div className="heat-profile-header-content">
                <div className="heat-profile-title-row">
                  <h3 className="heat-profile-list-title">List of Employees</h3>
                </div>
                <p className="heat-profile-list-description">
                  Manage employees details and cost center assignments.
                </p>
              </div>
            </div>

            <div className="heat-profile-header-actions calibration-modern-actions">
              <CrcButton
                label="Export"
                variant="tertiary"
                icon={Download}
                onClick={handleDownloadExcel}
                size="small"
              />
              <CrcButton
                label="Import"
                variant="tertiary"
                icon={Import}
                onClick={modalToImportFile}
                size="small"
              />
              <CrcButton
                label="Create New"
                variant="primary"
                icon={Plus}
                onClick={() => setFormModalVisible(true)}
                size="small"
              />
            </div>
          </div>

          <div className="heat-profile-table-wrap" style={{ marginTop: '16px' }}>
            <Table
              className="h-100 pipeline-table heat-profile-table equipment-types-table doc-control-users-table employees-list-table"
              columns={columns}
              dataSource={tableDataSource}
              loading={{
                spinning: isEmployeeListLoading,
                indicator: <Spinner variant="inline" size="large" color="#00C9A7" />,
              }}
              pagination={{
                current: current,
                pageSize: pageSize,
                total: tableDataSource.length,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (page, size) => {
                  setCurrent(page);
                  if (size) setPageSize(size);
                },
              }}
              rowKey="id"
            />
          </div>
        </div>
      </div>

      <Modal
        width={800}
        className="materials-modal-modern heatprofile-modal pipeline-modal"
        title={isEdit ? 'Update Employee' : 'Add New Employee'}
        style={{ top: 100 }}
        visible={formModalVisible}
        onCancel={handleCancel}
        footer={[
          <CrcButton
            key="cancel"
            label="Cancel"
            onClick={handleCancel}
            variant="tertiary"
            size="medium"
          />,
          <CrcButton
            key="submit"
            label={isEdit ? (isEmployeeListLoading ? 'Updating' : 'Update') : (isEmployeeListLoading ? 'Creating' : 'Create')}
            onClick={handleOk}
            disabled={isEmployeeListLoading}
            variant="primary"
            size="medium"
          />,
        ]}
      >
        <Form
          name="basic"
          layout="vertical"
          autoComplete="off"
          getcontainer={false}
          form={userForm}
        >
          <Row
            gutter={12}
          >
            <Col lg={8}>
              <Form.Item
                label="CoCd"
                name="coCd"
                required
              >
                <Input
                  placeholder="Enter CoCd"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="PersNo"
                name="personNumber"
                required
              >
                <Input
                  placeholder="Enter PersNo"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="Cost Ctr"
                name="costCenter"
                required
              >
                <Input
                  placeholder="Enter Cost Ctr"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="Name of Employee"
                name="employeeName"
                required
              >
                <Input
                  placeholder="Enter Name of Employee"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="Start Date"
                name="startDate"
                className="date-picker"
                required
              >
                <DatePicker
                  style={{ width: '100%' }}
                  size="large"
                  format="DD-MM-YYYY"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="End Date"
                name="endDate"
                className="date-picker"
                required
              >
                <DatePicker
                  style={{ width: '100%' }}
                  size="large"
                  format="DD-MM-YYYY"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        className="materials-modal-modern heatprofile-modal pipeline-modal admin-employees-upload-modal"
        title="Upload Employees Data"
        style={{ top: 100 }}
        visible={fileModalVisible}
        onCancel={handleCancelUploadFile}
        footer={[
          <CrcButton
            key="cancel"
            label="Cancel"
            onClick={handleCancelUploadFile}
            variant="tertiary"
            size="medium"
          />,
          <CrcButton
            key="apply"
            label={isEmployeeListLoading ? 'Uploading' : 'Upload'}
            onClick={handleFileUpload}
            disabled={isEmployeeListLoading}
            variant="primary"
            size="medium"
          />,
        ]}
      >
        <Form layout="vertical">
          <Row gutter={24}>
            <Col lg={24}>
              <Form.Item label="Upload Excel File">
                <Upload
                  {...fileProps}
                  maxCount={1}
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  className="calibration-upload-input-style"
                  listType="text"
                  showUploadList={{
                    showRemoveIcon: true,
                    showPreviewIcon: false,
                    removeIcon: <CloseOutlined className="admin-employees-upload-remove-icon" aria-label="Remove file" />,
                  }}
                >
                  <div className="calibration-upload-trigger">
                    <CloudUploadOutlined className="calibration-upload-icon" />
                    <span>Select File</span>
                  </div>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        width={440}
        centered
        className="materials-modal-modern heatprofile-modal pipeline-modal admin-employees-delete-modal"
        title="Delete employee"
        visible={deleteModalOpen}
        onCancel={handleDeleteModalCancel}
        destroyOnClose
        footer={[
          <CrcButton
            key="cancel"
            label="Cancel"
            onClick={handleDeleteModalCancel}
            variant="tertiary"
            size="medium"
          />,
          <Button
            key="delete"
            type="primary"
            danger
            onClick={handleConfirmDelete}
            className="admin-employees-delete-confirm-btn"
            size="large"
          >
            Delete
          </Button>,
        ]}
      >
        <div className="admin-employees-delete-body">
          <ExclamationCircleOutlined
            className="admin-employees-delete-icon"
            aria-hidden
          />
          <div>
            <p className="admin-employees-delete-lead">
              Are you sure you want to delete this employee? This action cannot be undone.
            </p>
            {employeeToDelete?.employeeName ? (
              <p className="admin-employees-delete-name">
                <span className="admin-employees-delete-name-label">Employee: </span>
                {employeeToDelete.employeeName}
              </p>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = ({ employeesReducer }) => {
  const employeeList = get(employeesReducer, 'employeesList', []);
  const isEmployeeListLoading = get(employeesReducer, 'isEmployeesListLoading', []);
  return {
    employeeList,
    isEmployeeListLoading,
  };
};

const mapDispatchToProps = {
  onFetchEmployeesList: fetchEmployeesList,
  onAddEmployee: addEmployee,
  onUploadBulkEmployeeList: uploadBulkEmployeeList,
  onUpdateEmployee: updateEmployee,
  onDeleteEmployee: deleteEmployee,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminEmployees);
